import * as semrush from '@anm/helpers/semrush';
import { FC } from 'react';

import TemplateListWithSlider from '../TemplateListWithSlider';
import TemplateVideoWithControls from '../TemplateVideoWithControls';

import TemplateWithSliderWrapper from './Wrapper';

type TemplateWithSliderProps = {
  onTemplateEdit(): void;
};

const TemplateWithSlider: FC<TemplateWithSliderProps> = props => (
  <TemplateWithSliderWrapper>
    <TemplateVideoWithControls
      variant="white"
      direction="column"
      orientation="horizontal_with_slider"
      heightDependence="screen_dependence_with_slider"
      showShareButton={!semrush.isSemrushIframe()}
      {...props}
    />
    <TemplateListWithSlider />
  </TemplateWithSliderWrapper>
);

export default TemplateWithSlider;
